'use client';

import notFound from "@std/app/not_found";

export default notFound;